
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/conversations/comments",
      function () {
        return require("private-next-pages/conversations/comments.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/conversations/comments"])
      });
    }
  